/**
 * Detail form fields for other-cost / sub-CO guided answers.
 */
import MoneyInput from '../../../../components/MoneyInput'

export default function QuestionDetailForm({
  mode,
  desc,
  setDesc,
  amount,
  setAmount,
  vendor,
  setVendor,
  due,
  setDue,
  paid,
  setPaid,
  category,
  setCategory,
  projectVendorId,
  setProjectVendorId,
  linkedOwnerCoId,
  setLinkedOwnerCoId,
  subOptions = [],
  ownerCos = [],
  busy,
  onSave,
}: {
  mode: 'other_costs' | 'sub_change_orders'
  desc: string
  setDesc: (v: string) => void
  amount: string
  setAmount: (v: string) => void
  vendor: string
  setVendor: (v: string) => void
  due: string
  setDue: (v: string) => void
  paid: boolean
  setPaid: (v: boolean) => void
  category: string
  setCategory: (v: string) => void
  projectVendorId?: number | ''
  setProjectVendorId?: (v: number | '') => void
  linkedOwnerCoId?: number | ''
  setLinkedOwnerCoId?: (v: number | '') => void
  subOptions?: Array<{ id: number; label: string }>
  ownerCos?: Array<{ id: number; label: string }>
  busy: boolean
  onSave: () => void
}) {
  return (
    <div className="cm-detail-form show" data-testid="cm-detail-form">
      <div className="cm-field cm-wide">
        <label>Description</label>
        <input value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="cm-detail-desc" />
      </div>
      {mode === 'other_costs' && (
        <div className="cm-field">
          <label>Category</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="materials">Materials</option>
            <option value="equipment">Equipment</option>
            <option value="permits">Permit</option>
            <option value="credit_card">Credit card</option>
            <option value="other">Other</option>
          </select>
        </div>
      )}
      <div className="cm-field">
        <label>Amount</label>
        <MoneyInput className="money" value={amount} onChange={setAmount} data-testid="cm-detail-amount" />
      </div>
      {mode === 'sub_change_orders' ? (
        <>
          <div className="cm-field">
            <label>Sub · required</label>
            <select
              value={projectVendorId === '' ? '' : String(projectVendorId)}
              onChange={(e) => {
                const v = e.target.value
                setProjectVendorId?.(v === '' ? '' : Number(v))
                const opt = subOptions.find((s) => String(s.id) === v)
                if (opt) setVendor(opt.label)
              }}
              data-testid="cm-detail-sub"
              required
            >
              <option value="">Select sub</option>
              {subOptions.map((s) => (
                <option key={s.id} value={s.id}>{s.label}</option>
              ))}
            </select>
          </div>
          <div className="cm-field">
            <label>Linked owner CO · optional</label>
            <select
              value={linkedOwnerCoId === '' || linkedOwnerCoId == null ? '' : String(linkedOwnerCoId)}
              onChange={(e) => {
                const v = e.target.value
                setLinkedOwnerCoId?.(v === '' ? '' : Number(v))
              }}
              data-testid="cm-detail-owner-co"
            >
              <option value="">None</option>
              {ownerCos.map((o) => (
                <option key={o.id} value={o.id}>{o.label}</option>
              ))}
            </select>
          </div>
        </>
      ) : (
        <div className="cm-field">
          <label>Vendor · optional</label>
          <input value={vendor} onChange={(e) => setVendor(e.target.value)} />
        </div>
      )}
      {mode === 'other_costs' && (
        <>
          <div className="cm-field">
            <label htmlFor="cm-paid-when">When is this paid?</label>
            <input
              id="cm-paid-when"
              type="date"
              required={!paid}
              value={due}
              onChange={(e) => setDue(e.target.value)}
              data-testid="cm-paid-when"
            />
          </div>
          <label className="cm-paid-toggle">
            <input type="checkbox" checked={paid} onChange={(e) => setPaid(e.target.checked)} />
            Already paid
          </label>
        </>
      )}
      <div className="cm-field cm-full">
        <button type="button" className="cm-btn cm-btn-dark" disabled={busy} onClick={onSave} data-testid="cm-detail-save">
          Save this {mode === 'sub_change_orders' ? 'change order' : 'cost'}
        </button>
      </div>
    </div>
  )
}
